import {
	Plus,
	Minus,
	ListOrdered,
	Shapes,
	Palette,
	Ruler,
	BookOpen,
} from "lucide-react";

/** Pick icon + label styling from category name / concept (fallback: generic). */
export function getTopicVisual(category) {
	const raw = `${category?.name || ""} ${category?.concept || ""}`.toLowerCase();

	if (raw.includes("addition") || raw.includes("add"))
		return { Icon: Plus, label: category?.name || "Addition" };
	if (raw.includes("subtract") || raw.includes("minus"))
		return { Icon: Minus, label: category?.name || "Subtraction" };
	if (
		raw.includes("number") ||
		raw.includes("count") ||
		raw.includes("digit")
	)
		return { Icon: ListOrdered, label: category?.name || "Numbers" };
	if (raw.includes("shape") || raw.includes("geometry") || raw.includes("solid"))
		return { Icon: Shapes, label: category?.name || "Shapes" };
	if (raw.includes("pattern"))
		return { Icon: Palette, label: category?.name || "Patterns" };
	if (
		raw.includes("measure") ||
		raw.includes("length") ||
		raw.includes("volume")
	)
		return { Icon: Ruler, label: category?.name || "Measurement" };

	return { Icon: BookOpen, label: category?.name || "Topic" };
}

/** Curriculum topic row: `{ kind: 'topic'|'other', id, name }` from teacher topic picker. */
export function getCurriculumTopicVisual(row) {
	if (row?.kind === "other") {
		return { Icon: BookOpen, label: row.name || "Other games" };
	}
	const raw = String(row?.name || "").toLowerCase();
	if (raw.includes("addition") || raw.includes("add"))
		return { Icon: Plus, label: row.name || "Addition" };
	if (raw.includes("subtract") || raw.includes("minus"))
		return { Icon: Minus, label: row.name || "Subtraction" };
	if (
		raw.includes("number") ||
		raw.includes("count") ||
		raw.includes("digit")
	)
		return { Icon: ListOrdered, label: row.name || "Numbers" };
	if (raw.includes("shape") || raw.includes("geometry") || raw.includes("solid"))
		return { Icon: Shapes, label: row.name || "Shapes" };
	if (raw.includes("pattern"))
		return { Icon: Palette, label: row.name || "Patterns" };
	if (
		raw.includes("measure") ||
		raw.includes("length") ||
		raw.includes("volume")
	)
		return { Icon: Ruler, label: row.name || "Measurement" };

	return { Icon: BookOpen, label: row.name || "Topic" };
}
